import { createStore } from '@oneappexchange/lwc-wired';
import { IS_DEVELOPMENT } from '~/modules/config';

export enum DeviceType {
    DESKTOP = 'desktop',
    TABLET = 'tablet',
    PHONE = 'phone',
}

export interface ViewportState {
    deviceType: DeviceType;
}

const initialState = {
    deviceType: DeviceType.DESKTOP,
} as ViewportState;

export const viewportStore = createStore(
    initialState,
    (set: SetState<ViewportState>, _: GetState<ViewportState>) => ({
        updateDeviceType() {
            const width = window.innerWidth || document.documentElement.clientWidth;
            let type: DeviceType;

            if (width >= 1024) {
                type = DeviceType.DESKTOP;
            } else if (width >= 768) {
                type = DeviceType.TABLET;
            } else {
                type = DeviceType.PHONE;
            }

            set(function updateDeviceType(draft) {
                draft.deviceType = type;
            });
        },
    }),
    'viewportStore',
    IS_DEVELOPMENT,
);

export function selectDeviceType(state: ViewportState) {
    return state.deviceType;
}

// To be executed when the file is imported
viewportStore.updateDeviceType();
window.addEventListener('resize', viewportStore.updateDeviceType);
